import {
  useGrimoireStore,
  usePlayersStore,
  useSessionStore,
} from "@/stores"
import type {
  Role,
} from "@/types"
export function updateFabled(fabled: Array<Role | { id: string; isCustom?: boolean }>) {
  const session = useSessionStore();
  if (!session.isPlayerOrSpectator) return;
  const playersStore = usePlayersStore();
  const grimoireStore = useGrimoireStore();
  playersStore.setFabled({
    fabled: fabled.map((f) => grimoireStore.fabled.get(f.id) || f),
  });
}
